import { Directive, ElementRef, Input, OnInit, HostListener, Optional, Renderer, Output, EventEmitter } from '@angular/core';
import {  NgControl } from '@angular/forms';
import * as $ from 'jquery';
import 'jquery-mask-plugin';
import * as Inputmask from 'inputmask';
import { InputMaskConfiguration, InputMaskProvider } from './inputmask.interfaces';
import { ThrowStmt } from '@angular/compiler';
import { WCCCustomEvents } from '../../helpers/wcc-custom-event';

@Directive({
  selector: '[appInputmask]',
  exportAs: 'appInputmask'
})
export class InputmaskDirective implements OnInit {
    triggers: string;
    lastValue: string;
    validConfig = false;

    @Input() prefix: string = null;
    @Input() suffix: string = null;
    @Input() appInputmask: string | InputMaskConfiguration = null;
    @Output() maskingValueChanged = new EventEmitter <any>();

    constructor(
        private el: ElementRef,
        private renderer: Renderer,
        @Optional() private control: NgControl
    ) {
    }

    ngOnInit() {
        this.initConfigurations();
        this.parseTriggers();
        this.maskElement();

        this.lastValue = this.el.nativeElement.value;
        this.control.control.setValue(this.el.nativeElement.value);
    }

    public getPrefixSuffix () {
        let prefix = '';
        let suffix = '';
        if (typeof this.appInputmask === 'object') {
            if (typeof this.appInputmask.settings === 'object') {
                const settings = <any> this.appInputmask.settings;
                if (settings.prefix !== undefined && settings.prefix !== null) {
                    prefix = settings.prefix;
                }
                if (settings.suffix !== undefined && settings.suffix !== null) {
                    suffix = settings.suffix;
                }
            }
        }
        return {
            prefix,
            suffix
        };
    }

    public maskElement() {
        const elem: any = $(this.el.nativeElement);
        this.validConfig = this.isValidValue(this.appInputmask);
        if (this.validConfig) {
            if (typeof this.appInputmask !== 'string') {
                if (this.appInputmask.provider === InputMaskProvider.IgoreScobar) {
                    elem.mask(this.appInputmask.mask, this.appInputmask.settings || '');
                }
                if (this.appInputmask.provider === InputMaskProvider.RobinHerbots) {
                    Inputmask(this.appInputmask.mask, this.appInputmask.settings).mask(elem);
                }
            } else {
                elem.mask(this.appInputmask, {clearMaskOnLostFocus: false});
            }
        }
    }

    public maskedValue (value: string = null): string {
        const elem = (<any> $(this.el.nativeElement));
        const val = value === null ? this.el.nativeElement.value : value;
        if (elem.data('mask') === undefined) {
            return val;
        }
        return elem.masked(val);
    }

    public cleanValue (): string {
        const elem: any = $(this.el.nativeElement);
        if (typeof this.appInputmask === 'object') {
            if (this.appInputmask.provider === InputMaskProvider.RobinHerbots) {
                return Inputmask.unmask(elem.val(), {
                    alias: this.appInputmask.mask
                });
            }
        }
        return elem.cleanVal();
    }

    private isValidValue (val: any) {
        return val !== null && val !== undefined;
    }

    @HostListener('blur', ['$event'])
    private onBlur(event) {
        if (this.isEventInTrigger('blur') && this.el.nativeElement.contains(event.target) && this.validConfig) {
            if (this.lastValue === event.target.value) {
                return false;
            }
            this.maskElement();
            this.lastValue = event.target.value;
            this.control.control.setValue(event.target.value);

            if (typeof this.appInputmask === 'object') {
                // Manually trigger change because of this provider is blocking the native change event.
                if (this.appInputmask.provider === InputMaskProvider.RobinHerbots) {
                    const _event = new WCCCustomEvents('change', {bubbles: true});
                    this.renderer.invokeElementMethod(event.target, 'dispatchEvent', [_event]);
                }
            }
        }
    }

    @HostListener('change', ['$event'])
    private onChange(event) {
        if (this.isEventInTrigger('change') && this.el.nativeElement.contains(event.target) && this.validConfig) {
            this.maskElement();
            this.control.control.setValue(event.target.value);
        }
    }

    @HostListener('keypress', ['$event'])
    private onKeypress(event) {
        const elem: any = $(this.el.nativeElement);
        const noLeadingZero = elem.attr('noLeadingZero');
        if (typeof noLeadingZero !== typeof undefined && noLeadingZero !== false && this.validConfig) {
            const currentVal = parseFloat(event.target.value.replace(/,/g, ''));
            const selStart = event.target.selectionStart;
            const selEnd = event.target.selectionEnd;

            if (String(event.key) === '0' && (selStart === 0 && selEnd === 0) && currentVal > 0) {
                event.preventDefault();
                return false;
            } else if (String(event.key) === '0' && (selStart === 1 && selEnd === 1) && currentVal === 0) {
                event.preventDefault();
                return false;
            }
        }
    }

    @HostListener('keyup', ['$event'])
    private onKeyUp (event) {
        if (this.validConfig) {
            const val = $(this.el.nativeElement).val();
            let isDefault = true;
            if (typeof this.appInputmask === 'object') {
                if (this.appInputmask.provider === InputMaskProvider.RobinHerbots) {
                    isDefault = false;
                    Inputmask(this.appInputmask.mask, this.appInputmask.settings).mask(this.el.nativeElement);
                }
            }
            if (isDefault) {
                (<any> $(this.el.nativeElement)).masked(val);
            }

            this.maskingValueChanged.emit($(this.el.nativeElement).val());
        }
    }

    @HostListener('paste', ['$event'])
    private onPaste(event) {
    }

    isEventInTrigger(trigger: string): any {
        if (this.triggers !== null) {
            return this.triggers.indexOf(trigger) > -1;
        }
        return true;
    }

    parseTriggers(): void {
        const triggersAttr = this.el.nativeElement.getAttribute('appInputmask-triggers');
        if (triggersAttr !== null) {
            this.triggers = triggersAttr.split(':');
        } else {
            this.triggers = null;
        }
    }

    private initConfigurations (): void {
        const currentConfig = this.appInputmask;
        if (typeof currentConfig === 'object') {
            const defaultConfig: InputMaskConfiguration = {
                provider: InputMaskProvider.IgoreScobar
            };
            Object.assign(defaultConfig, currentConfig);
            this.appInputmask = defaultConfig;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/inputmask/inputmask.directive.ts